import { tx } from '@/i18n/pack';

/** 加购推荐卡片现网中文 → 词表。接口若带回同一句中文也走这里，其它原文不译。 */
const COPY: Record<string, [string, string]> = {
  推荐开启: ['form.list.badge.recommend', '推荐开启'],
  '加购却没结账的顾客，适合开启': ['form.recommend.titlePrefix', '加购却没结账的顾客，适合开启'],
  '【新客加购订阅弹窗】': ['form.recommend.titleHighlight', '【新客加购订阅弹窗】'],
  '【目标用户】有购买意向，但未留下邮箱/手机号的用户': [
    'form.recommend.target',
    '【目标用户】有购买意向，但未留下邮箱/手机号的用户',
  ],
  '【场景】精准提订阅、少打扰，弹窗只在用户加购后未结算时出现，不打断正常下单，购物车/结算页默认不出现': [
    'form.recommend.scene',
    '【场景】精准提订阅、少打扰，弹窗只在用户加购后未结算时出现，不打断正常下单，购物车/结算页默认不出现',
  ],
  预览并开启: ['form.recommend.previewEnable', '预览并开启'],
  暂不推荐: ['form.recommend.notNow', '暂不推荐'],
};

export function recommendCopy(text?: string | null) {
  if (!text) {
    return '';
  }
  const hit = COPY[text];
  if (hit) {
    return tx(null, hit[0], hit[1]);
  }
  return text;
}

/** 创建弹窗时把模板库中文名翻成当前 UI 语言，再拼随机后缀写入 form.name。 */
export function localizeFormTemplateName(name?: string | null) {
  if (!name) {
    return '';
  }
  const recommended = recommendCopy(name);
  if (recommended !== name) {
    return recommended;
  }
  return tx(null, `form.catalog.template.${name}`, name);
}
